import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { appSettingsControllerFindAll, appSettingsControllerUpdate } from '@klubovna/api-client';
import { AppSetting } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(): Observable<AppSetting[]> {
    return appSettingsControllerFindAll(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body as AppSetting[]));
  }

  update(key: string, value: string): Observable<AppSetting> {
    return appSettingsControllerUpdate(this.http, this.apiConfig.rootUrl, { key, body: { value } })
      .pipe(map(response => response.body as AppSetting));
  }
}
